import { downloadFile, nanoSecondsToDate } from 'utils';
import { formatTokenAmount } from 'utils/amounts';
import useNormalizeType from './use-normalize-type';
import { listActivities } from 'services/indexer';

const fetchAllActivities = async (accountId, type, date) => {
  try {
    let isPending = true;
    let page = 1;
    const data = [];

    while (isPending) {
      const { result } = await listActivities({ accountId, page, type, date });
      const hits = result?.hits?.hits || [];

      if (!hits.length) {
        isPending = false;
        break;
      }

      data.push(...hits);
      page += 1;
    }

    return data;

  } catch (e) {
    console.error(`Failed to fetch activity: ${e}`);
    return [];
  }
};

export const exportToCsv = async (accountId, type, date) => {
  const data = await fetchAllActivities(accountId, type, date);

  if (!data.length) return;

  const headers = ['Created at, Type, Asset, Amount, Destination'];

  const csv = data.reduce((acc, { _source }) => {
    const { activity_data, date_added } = _source;
    const { amount, label, title } = useNormalizeType(_source);

    acc.push(
      [
        nanoSecondsToDate(date_added, true),
        title,
        label,
        formatTokenAmount(amount, 24, 5),
        activity_data.receiver_id
      ].join(',')
    );
    return acc;
  }, []);

  downloadFile({
    data: [...headers, ...csv].join('\n'),
    fileName: 'activity-csv.csv',
    fileType: 'text/csv'
  });
};
